/**
 * Created by methee on 9/12/17.
 */
/* eslint-disable react/no-array-index-key, no-param-reassign, camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';

import s from './Nearby.css';
import iconFeatured from './icon-featured.webp';
import iconFeaturedAdd2x from './icon-featured@2x.webp';
import iconLeft from './icon-left.webp';
import iconLeftAdd2x from './icon-left@2x.webp';
import iconRight from './icon-right.webp';
import iconRightAdd2x from './icon-right@2x.webp';

const messages = defineMessages({
  viewOnMap: {
    id: 'hotel.nearby_view_on_map',
    defaultMessage: '##View on map##',
    description: 'Link to view nearby place on google map',
  },
  viewOnFoursquare: {
    id: 'hotel.nearby_view_on_foursquare',
    defaultMessage: '##View on Foursquare##',
    description: 'Link to view nearby place on foursquare',
  },
  legendMeaning: {
    id: 'hotel.legendMeaning',
    defaultMessage:
      'This legend means 10% off the total bill for Remembered member',
    description: 'Link to view nearby place on foursquare',
  },
});

class Nearby extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nearbyPlaces: [],
      atPage: 1,
    };
  }

  async componentDidMount() {
    if (process.env.BROWSER) {
      await this.getNearby(this.props);
    }
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.hotelId !== this.props.hotelId ||
      nextProps.category !== this.props.category
    ) {
      await this.getNearby(nextProps);
    }
  }

  onPrevPage = () => {
    const { nearbyPerPage } = this.props;
    const { nearbyPlaces } = this.state;
    let { atPage } = this.state;
    const pagesCount = Math.ceil(nearbyPlaces.length / nearbyPerPage);
    atPage -= 1;
    if (atPage < 1) {
      atPage = pagesCount;
    }
    this.setState({ atPage });
  };

  onNextPage = () => {
    const { nearbyPerPage } = this.props;
    const { nearbyPlaces } = this.state;
    let { atPage } = this.state;
    const pagesCount = Math.ceil(nearbyPlaces.length / nearbyPerPage);
    atPage += 1;
    if (atPage > pagesCount) {
      atPage = 1;
    }
    this.setState({ atPage });
  };

  async getNearby({ getNearby, hotelId, category }) {
    const nearbyPlaces = await getNearby(hotelId, category);
    this.setState({ nearbyPlaces, atPage: 1 });
  }

  render() {
    const { nearbyPerPage } = this.props;
    const { nearbyPlaces, atPage } = this.state;
    if (nearbyPlaces.length === 0) {
      return null;
    }
    const columns = [];
    const pagesCount = Math.ceil(nearbyPlaces.length / nearbyPerPage);
    const pages = [];
    for (let i = 1; i <= pagesCount; i += 1) {
      pages.push(
        <li key={i} className={cx(atPage === i && s.selected)}>
          <button
            type="button"
            onClick={() => {
              this.setState({ atPage: i });
            }}
          >
            {i}
          </button>
        </li>,
      );
    }
    let index = atPage * nearbyPerPage - nearbyPerPage;
    const progress = nearbyPlaces.slice(index);
    const firstNearby = progress[0];
    if (firstNearby.website) {
      if (firstNearby.website.toLowerCase().indexOf('http') !== 0) {
        firstNearby.website = `http://${firstNearby.website}`;
      }
    }
    if (firstNearby.url) {
      if (firstNearby.url.toLowerCase().indexOf('http') !== 0) {
        firstNearby.url = `http://${firstNearby.url}`;
      }
    }
    const places = progress.slice(1);
    places.forEach(place => {
      if (place.website) {
        if (place.website.toLowerCase().indexOf('http') !== 0) {
          place.website = `http://${place.website}`;
        }
      }
      if (place.url) {
        if (place.url.toLowerCase().indexOf('http') !== 0) {
          place.url = `http://${place.url}`;
        }
      }
    });
    index = 0;
    const numberOfColumns = Math.floor(nearbyPerPage / 3);
    while (columns.length < numberOfColumns) {
      const span = 3;
      columns.push([...places.slice(index, index + span)]);
      index += 3;
    }
    return (
      <div className={s.root}>
        <div className={s.legend}>
          <img
            src={iconFeatured}
            srcSet={`${iconFeaturedAdd2x} 2x`}
            alt="icon featured"
          />
          <FormattedMessage {...messages.legendMeaning} />
        </div>
        <div className={s.row}>
          <div className={s.col4}>
            <div className={cx(s.box, s.big)}>
              <a
                href={firstNearby.website || firstNearby.url}
                hrefLang={this.context.intl.locale}
                target="tap"
              >
                <div
                  className={s.image}
                  style={{ backgroundImage: `url('${firstNearby.image}')` }}
                >
                  {firstNearby.is_featured && (
                    <img
                      src={iconFeatured}
                      srcSet={`${iconFeaturedAdd2x} 2x`}
                      alt="icon featured"
                    />
                  )}
                </div>
              </a>
              <div className={s.content}>
                <div className={s.row}>
                  <div className={s.col6}>
                    <a
                      href={firstNearby.website || firstNearby.url}
                      hrefLang={this.context.intl.locale}
                      target="tap"
                    >
                      <h5>{firstNearby.name}</h5>
                    </a>
                    <div className={s.highlight}>
                      {firstNearby.promotion_text}
                    </div>
                  </div>
                  <div className={s.col6}>
                    <div className={s.tel}>
                      <a
                        href={`tel:${firstNearby.telephone}`}
                        hrefLang={this.context.intl.locale}
                      >
                        {firstNearby.telephone}
                      </a>
                    </div>
                    <div className={s.promoText}>
                      {firstNearby.promotion_text}
                    </div>
                    <div className={s.map}>
                      <a
                        href={`https://www.google.com/maps/place/${firstNearby.coordinate}`}
                        hrefLang={this.context.intl.locale}
                        target="tap"
                      >
                        <FormattedMessage {...messages.viewOnMap} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {columns.map((col, id) => (
            <div key={Math.floor(Math.random() * 100) + id} className={s.col4}>
              {col.map(place => (
                <div
                  key={Math.floor(Math.random() * 100) + place.name}
                  className={cx(s.box, place.is_featured && s.featured)}
                >
                  <a
                    href={place.website || place.url}
                    hrefLang={this.context.intl.locale}
                    target="__blank"
                  >
                    <div
                      className={s.image}
                      style={{ backgroundImage: `url('${place.image}')` }}
                    >
                      {place.is_featured && (
                        <div className={s.featuredImage}>
                          <img
                            src={iconFeatured}
                            srcSet={`${iconFeaturedAdd2x} 2x`}
                            alt="icon featured"
                          />
                        </div>
                      )}
                    </div>
                  </a>
                  <div className={s.content}>
                    <a
                      href={place.website || place.url}
                      hrefLang={this.context.intl.locale}
                      target="__blank"
                    >
                      <h5>{place.name}</h5>
                    </a>
                    <div className={s.category}>
                      {place.sub_category_name || place.category_name}
                    </div>
                    <div className={s.promoText}>{place.promotion_text}</div>
                    <div className={s.map}>
                      <a
                        href={`https://www.google.com/maps/place/${place.coordinate}`}
                        hrefLang={this.context.intl.locale}
                        target="tap"
                      >
                        <FormattedMessage {...messages.viewOnMap} />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className={s.paging}>
          <button type="button" onClick={this.onPrevPage}>
            <img
              src={iconLeft}
              srcSet={`${iconLeftAdd2x} 2x`}
              alt="icon left"
            />
          </button>
          <ul>{pages}</ul>
          <button type="button" onClick={this.onNextPage}>
            <img
              src={iconRight}
              srcSet={`${iconRightAdd2x} 2x`}
              alt="icon right"
            />
          </button>
        </div>
      </div>
    );
  }
}

Nearby.propTypes = {
  nearbyPerPage: PropTypes.number,
  getNearby: PropTypes.func.isRequired,
  hotelId: PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
};

Nearby.defaultProps = {
  nearbyPerPage: 7,
};

Nearby.contextTypes = {
  intl: intlShape,
};

export default withStyles(s)(Nearby);
